var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M18.939 17.8774L14.205 9.01013V4.50787H14.6734C14.8808 4.50787 15.0484 4.34025 15.0484 4.13287V3.375C15.0484 3.168 14.8808 3 14.6734 3H14.205H9.3904H8.96178C8.7544 3 8.58678 3.168 8.58678 3.375V4.13287C8.58678 4.34025 8.7544 4.50787 8.96178 4.50787H9.3904V9.0105L5.0329 17.8387C3.91878 19.5847 4.69465 21 6.7654 21H17.2654C19.3362 21 20.0854 19.602 18.939 17.8774ZM10.7355 9.67425L10.8904 9.36038V9.0105V4.50787H12.705V9.0105V9.38587L12.8817 9.717L14.9104 13.5165H8.83915L10.7355 9.67425Z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }